import {Booking} from "../../../../core/entities/booking/domain/models/booking.model";
import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

export class BookingFetchedEvent implements DomainEvent {
  readonly occurredAt = new Date();
  readonly eventType = 'BookingFetchedEvent';

  constructor(public readonly booking: Booking) {
  }
}
